import { render, staticRenderFns } from "./AdvancedSetting.vue?vue&type=template&id=0a35cd05&scoped=true"
import script from "./AdvancedSetting.vue?vue&type=script&lang=js"
export * from "./AdvancedSetting.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSetting.vue?vue&type=style&index=0&id=0a35cd05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a35cd05",
  null
  
)

export default component.exports